import { Navigate, Route, Routes } from 'react-router-dom';
import { useApp } from './AppContext';
import { Layout } from './Layout';
import { Login } from '../pages/Login';
import { Invite } from '../pages/Invite';
import { Shop } from '../pages/Shop';
import { MyReservations } from '../pages/MyReservations';
import { Catalog } from '../pages/admin/Catalog';
import { MediaLibrary } from '../pages/admin/MediaLibrary';
import { Allocation } from '../pages/admin/Allocation';
import { Reports } from '../pages/admin/Reports';
import { People } from '../pages/admin/People';
import { Settings } from '../pages/admin/Settings';
import type { ReactNode } from 'react';

function AdminOnly({ children }: { children: ReactNode }) {
  const { isAdmin } = useApp();
  return isAdmin ? <>{children}</> : <Navigate to="/" replace />;
}

export function App() {
  const { ready, signedIn } = useApp();
  if (!ready) return <div className="loading">Loading…</div>;
  if (!signedIn) {
    return (
      <Routes>
        <Route path="/invite" element={<Invite />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/invite" element={<Navigate to="/" replace />} />
        <Route path="/" element={<Shop />} />
        <Route path="/my" element={<MyReservations />} />
        <Route path="/admin/catalog" element={<AdminOnly><Catalog /></AdminOnly>} />
        <Route path="/admin/media" element={<AdminOnly><MediaLibrary /></AdminOnly>} />
        <Route path="/admin/allocation" element={<AdminOnly><Allocation /></AdminOnly>} />
        <Route path="/admin/reports" element={<AdminOnly><Reports /></AdminOnly>} />
        <Route path="/admin/people" element={<AdminOnly><People /></AdminOnly>} />
        <Route path="/admin/settings" element={<AdminOnly><Settings /></AdminOnly>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
